/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useEffect, useState } from "react";

const RemoteSvg = (props) => {
    const url = props?.url ?? "";

    const [svg, setSvg] = useState(null);

    useEffect(() => {
        fetch(url)
            .then(async (res) => {
                let html = await res.text();
                const regex = /fill="(#?([0-9a-fA-F]{3}|[0-9a-fA-F]{6}))"/g;
                html = html?.replace(regex, 'fill="currentColor"');
                return html;
            })
            .then(setSvg);
    }, [url]);

    return svg ? (
        <div
            className={"simplicity-remote-svg"}
            dangerouslySetInnerHTML={{ __html: svg }}
        />
    ) : null;
};

export { RemoteSvg };
